import { jsx as _jsx } from "react/jsx-runtime";
import { InputWrapper } from "./InputWrapper";
export const Select = (props) => {
    const { formLabel, errorMessage, options, ...rest } = props;
    return (_jsx(InputWrapper, { formName: rest.name, formLabel: formLabel, errorMessage: errorMessage, children: _jsx("select", { ...rest, children: options.map(({ value, label }) => (_jsx("option", { value: value, children: label }, value))) }) }));
};
